import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {ASSET_CONFIG} from '../../../models/dialogModels';
import {getChildObjectComponentByType} from "../../../helpers/componentHelper";

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class Video extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            videoType:{},
            video: {
                src: "",
            },
            screenStatus: "",
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
            replay_label: appHelper.getLocaleString("replay_label"),
            play_label: appHelper.getLocaleString("play_label"),
            video_instruction: appHelper.getLocaleString("video_instruction"),
            continue_label: appHelper.getLocaleString("continue_label"),
        };

        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.setClass = this.setClass.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getControlClass = this.getControlClass.bind(this);
        this.launchVideo = this.launchVideo.bind(this);

        this.onCloseVideoDialog = this.onCloseVideoDialog.bind(this);
        this.setStatusClass = this.setStatusClass.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onRendered = this.onRendered.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getCaptionPath = this.getCaptionPath.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);


    }

    componentDidMount() {
        this.getAssets();
        this.getScreenStatus();
        this.show();

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            let video = appHelper.getVideoAsset(this.state.screenObject);
            video = appHelper.getLocalData(video);
            let videoType = Object.assign({}, getChildObjectComponentByType(`${video.sub_type}`));
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video,
                videoType: appHelper.isDefined(video) && video.src.length > 0 ? videoType : this.state.videoType,
                download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
                replay_label: appHelper.getLocaleString("replay_label"),
                play_label: appHelper.getLocaleString("play_label"),
                video_instruction: appHelper.getLocaleString("video_instruction"),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
        }
    }

    getCaptionPath(captions) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(captions) && captions.length > 0) {
                return require(`../../../../moveToDist/${captions}`);
            }
        } else {
            return captions;
        }
    }

    onLinkClick(event){
        event.stopPropagation();
    }

    getScreenStatus(){
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {
        let video = appHelper.getVideoAsset(this.state.screenObject);
        video = appHelper.getLocalData(video);
        let videoType = Object.assign({}, getChildObjectComponentByType(`${video.sub_type}`));
        if (appHelper.isDefined(video) && video.src.length > 0) {
            this.setState({
                video: video,
                videoType: videoType
            });
        }
    }

    show() {
        let optionRef = this.refs[`${this.state.screenObject.asset_id}_asset`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onRendered);
    }

    onRendered(){
        if(this.state.isResourceObject){
            this.props.callbacks.onObjectRendered();
        }
        this.getObjectStatus();
    }

    getObjectStatus() {

        if(this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.onComplete();
        }else{
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                }else if(this.state.isResourceObject){
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }else{
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }

            if(!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE){
                this.setState({status: objectConstants.STATUS_COMPLETE});
                this.onComplete();
            }

        }

    }

    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
        if(!this.state.screenObject.required_for_completion || this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.onComplete();
        }
    }


    scrollToTop() {
        if(this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`${this.state.screenObject.asset_id}_asset`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)){
            if(!hasNextObject && !this.state.isResourceObject) {
                this.handleProgression();
                this.enableProgression();
            }else if(!hasNextObject && this.state.isResourceObject){
                this.handleProgression();
            }else if(this.state.isResourceObject) {
                this.handleProgression();
            }else{
                this.enableProgression();
            }

        }else{
            this.handleProgression();
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked(){
        this.setState({showProgressionButton: false});
        if(this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject){
            this.handleProgression();
        }else{
            this.props.callbacks.navigateToNextScreen();
        }
    }

    setClass() {
    }

    getControlClass(){
        return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
    }


    onCloseVideoDialog(viewed){
        if(this.state.status !== objectConstants.STATUS_COMPLETE && viewed){
            this.setState({
                status: objectConstants.STATUS_COMPLETE
            });
            this.onComplete();
        }
    }



    launchVideo(){
        let childComponenents = [];
        let config = Object.assign({}, ASSET_CONFIG,
            {
                title: this.state.locale.label,
                sourceId: `video_player_${this.state.screenObject.asset_id}`,
                onClose: this.onCloseVideoDialog,
                showCloseBtn: false,
                theme: "dialog-asset-image"
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child = Object.assign({},child,{
                childComponent: this.state.videoType.component,
                componentProps: Object.assign({}, {
                    screenObject: this.state.screenObject,
                    callbacks: this.props.callbacks,
                    video: this.state.video
                })
            });

            childComponenents = dataHelper.immutablePush(childComponenents, child);
        }
        config = Object.assign({},config,{
            childComponents: childComponenents
        });

        this.props.actions.setNewAssetDialog(config);
    }

    setStatusClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "viewed";
        } else {
            return "not-viewed";
        }

    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.launchVideo();
        }
    }

    render() {
        return (
            <div>
                <div className={`object-container`} ref={`${this.state.screenObject.asset_id}_asset`}>
                    <div>

                        <div className={`video-container`} onClick={this.launchVideo} onKeyDown={this.setKeyboardAccessibility} tabIndex="0" role="link" id={`video_player_${this.state.screenObject.asset_id}`}>
                            <div className="video-thumbnail-wrapper">
                                <div className={`video-controls ${this.getControlClass()}`} >
                                    <img src={this.getImagePath(this.state.video.thumbnail)} alt=""/>
                                </div>
                            </div>
                            <div className="video-details">
                                {
                                    this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                        ? <h4 className={this.setStatusClass()} dangerouslySetInnerHTML={{__html:this.state.locale.label}}/>
                                        : null
                                }
                                {
                                    appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                        ? <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                        : null
                                }
                                {
                                    appHelper.isDefined(this.state.video.txt) && this.state.video.txt.length > 0
                                        ?
                                        <p className="video-transcript"><a href={this.getCaptionPath(this.state.video.txt)} download target="_blank" tabIndex={0} onClick={this.onLinkClick}  className="document" >{this.state.download_transcript_label}</a></p>
                                        :
                                        null
                                }
                                {
                                    this.state.status === objectConstants.STATUS_COMPLETE
                                        ? <div className="icon-first video-icon icon icons8-publish">{this.state.replay_label}</div>
                                        :

                                            <div className="icon-first video-icon icon icons8-play">{this.state.play_label}
                                                {this.state.screenObject.required_for_completion && !this.state.isResourceObject
                                                    ?
                                                    <span> - <em>{this.state.video_instruction}</em></span>
                                                    : null
                                                }
                                            </div>
                                }
                            </div>
                        </div>

                    </div>

                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>
        );
    }
}

Video.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Video.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Video);



/** WEBPACK FOOTER **
 ** ./src/components/objects/video/Video.js
 **/